/// <amd-module name="Widgets/Configs/PullrequestWidgetConfig/PullRequestManager" />
import { SettingsManagerBase } from "WidgetCommon/ModernWidgetTypes/SettingsManagerBase";
import { PullRequestWidgetSettings } from "WidgetCommon/ConfigContracts/PullRequestsWidgetSettings";
import { IListBoxItem } from "VSSUI/ListBox";
import { WebApiTeam } from "Tfs/Platform/Contracts/Core";

export class PullRequestWidgetConstants {
    /* Constant values (DEFAULT_MAX_QUERY_RESULT_COUNT and DEFAULT_MAX_REPOSITORY_SELECTION)
     * have been set after calculating db feasibility 
    */
    static DEFAULT_MAX_QUERY_RESULT_COUNT: number = 20;
    static DEFAULT_MAX_REPOSITORY_SELECTION: number = 10;
}

export enum SortCriteria {
    CreatedDate = 0
}

export enum QueryType {
    CreatedByMe = 1,
    AssignedToMe = 2,
    AssignedToTeam = 3,
}

export enum PullRequestStatusState {
    Success, // Good!
    Pending, // In progress
    Failure, // Bad
    Waiting,  // Waiting on author
    Info,
}

export enum PullRequestVoteStatus {
    APPROVE = 10,
    APPROVE_WITH_COMMENT = 5,
    NONE = 0,
    NOT_READY = -5,
    REJECT = -10
}

export enum PullRequestVoteIconMap {
    APPROVE = "bowtie-icon bowtie-status-success",
    APPROVE_WITH_COMMENT = "bowtie-icon bowtie-status-success",
    NONE = "bowtie-icon bowtie-math-minus-circle",
    NOT_READY = "bowtie-icon bowtie-status-waiting-fill",
    REJECT = "bowtie-icon bowtie-status-failure"
};

export enum PullRequestVoteIconMessage {
    APPROVE = "Approved",
    APPROVE_WITH_COMMENT = "Approved with comment",
    NONE = "No response",
    NOT_READY = "Waiting for author",
    REJECT = "Rejected"
};

export class PullRequestManager extends SettingsManagerBase<PullRequestWidgetSettings> {

    private teamOptions: IListBoxItem<WebApiTeam>[];
    private currentTeamId: string;

    constructor(_teamOptions: IListBoxItem<WebApiTeam>[], _currentTeamId: string){
        super();
        this.teamOptions = _teamOptions;
        this.currentTeamId = _currentTeamId;
    }

    getFeatureName(): string {
        return "PullRequestWidgetConfig";
    }
    

    generateDefaultSettings(): Promise<PullRequestWidgetSettings> {
        const defaultTeamOption = this.teamOptions?.find(teamOption => teamOption.id === this.currentTeamId);
        const settigs: PullRequestWidgetSettings = {
            queryType: QueryType.AssignedToTeam,
            teamId: defaultTeamOption && defaultTeamOption != undefined ? defaultTeamOption.id : null
        } as PullRequestWidgetSettings;

        return Promise.resolve(settigs);
    }
}